<template>
    <div>
        <x-grid :id="'childGrid'"
                :columns="columns"
                :toolbar-config="toolbarConfig"
                :editable="true"
                :edit-rules="editRules"
                :editConfig="editConfig"
                ref="grid"
        >
            <template v-slot:[toolbarConfig.templatelSlots]>
                <vxe-button @click="addProp()">新增</vxe-button>
<!--                <vxe-button @click="delRow()">删除</vxe-button>-->
            </template>
        </x-grid>

    </div>
</template>

<script>
    import XGrid from '@/components/grid/XGridChild'
    import {GridChildMixin} from "@/utils/GridChildMixin";
    import {
        formatter as fmt
    } from "@/utils/ebase-formatter"
    //import {FormChildTable} from "@/utils/FormChildTable";

    const fac = XGrid.factory;
    console.info(fmt);//防止不使用便利 eslint报错

    //列
    const columns = [
        fac.makeColumnCheckboxDefault(),
        fac.makeColumn({
            field: "codeId",
            title: "代码Id",
            width: 200,
            /* editRender: {
                 : 'input',
             },
             editRules: [{required: true}],*/
        }),
        fac.makeColumn({
            field: "codeName",
            title: "代码名称",
            width: 200,
            editRender: {
                name: 'input',
            },
            editRules: [{required: true}],
        }),
        fac.makeColumn({
            field: "isUse",
            title: "是否使用",
            width: 140,
            align: 'center',
            editRender: {
                name: '$switch',
                defaultValue: 0,
                props: {
                    'open-label': "是",
                    'close-label': '否',
                    'open-value': true,
                    'close-value': false,
                },
            },
            formatter: fmt.formatYesNo
        }),
         fac.makeColumn({
            field: "isVisible",
            title: "是否可见",
            width: 140,
            align: 'center',
            editRender: {
                name: '$switch',
                props: {
                    'open-label': "是",
                    'close-label': '否',
                    'open-value': true,
                    'close-value': false,
                },
            },
            formatter: fmt.formatYesNo
        }),
        fac.makeColumn({
            field: "codeValue",
            title: "代码值",
            width: 200,
            editRender: {
                name: 'input',
            },
        }),
        fac.makeColumn({
            field: "orderNum",
            title: "显示顺序",
            width: 100,
            editRender: {
                name: 'input',
                attrs: {type: 'number'}
            },
        }),
        fac.makeColumn({
            field: "remark",
            title: "备注",
            width: 200,
            editRender: {
                name: 'input',
            },
        }),
    ]


    //可编辑表格规则 没有特殊要求的不改
    const editRules = fac.makeEditRules(columns);

    //工具栏按钮 没有可删除
    const toolbarConfig = fac.makeToolbarConfig({
        templatelSlots: 'toolbarBtns'
    });
    //编辑配置
    const editConfig = fac.makeEditConfig();

    export default {
        /*props: {
            rowId: {
                type: String,
                default: ''
            },
        },*/
        mixins: [GridChildMixin],
        components: {
            //baseCodeTableModal
        },
        data() {
            return {
                toolbarConfig,
                editRules,
                columns,
                editConfig,
            }
        },
        methods: {
            /**
             * 方法名要与弹出层表格一致 建议固定
             * 获取子表弹出层的数据并插入子表
             * 调用FormChildTable.insertRow方法 将处理字段传入方法 对回调数据进行过滤或调整
             */
            addProp() {
                this.addRow({
                    isUse: true,
                })
            },
        }
    }
</script>

<style scoped>
    .vxe-toolbar {
        padding-left: 0
    }
</style>